import * as log from "loglevel";
import {game} from "../GameCore";
import {gameConfig} from "../config/GameConfig";
import {showSecondaryScreen, getSecondaryScreen} from '../../screens/ScreenManager';
import {pauseScreenVisible} from '../../screens/gameplay/pause-menu/PauseOverlay';

var resize_delay: number;


/**
 * set game scaling properties
 * @param phaserGame
 */
export function setScaling()
{
    //  set the scaling mode for the game;
    //  we're using user-controlled scaling

    game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;

    //  add window listeners so we can resize the game as the browser resizes

    window.addEventListener('resize', onWindowResize);

    //  do initial scale

    // scaleGameToWindow();
}


/**
 * when the window size changes, scale the game to match after a short delay
 */
function onWindowResize()
{
    //  pause the game when we resize

    game.paused = true;

    //  show the pause menu

    pauseScreenVisible(true);

    //  clear the timeout if one is in progress

    if (resize_delay) clearTimeout(resize_delay);

    //  restart timeout

    resize_delay = setTimeout(scaleGameToWindow, 50);
}


/**
 * the screen size has changed
 */
export function scaleGameToWindow()
{
    var xScale: number,
        yScale: number,
        scaledWidth: number,
        xTrim: number,
        yTrim: number;

    //  we want to scale the game to always fit in 10 tiles in height;
    //  the x-scale should always match this

    yScale = game.scale.parentNode.offsetHeight / game.height;
    xScale = game.scale.parentNode.offsetWidth / game.width;

    //  set scaling

    game.scale.setUserScale(xScale, yScale, 0, 0);

    //  get new game width

    scaledWidth = game.width * (game.scale.parentNode.offsetWidth / (game.width * yScale));

    //  resize the renderer to make things full screen

    (<any>game.renderer).resize(scaledWidth, 640);

    //  set the new world width

    game.world.width = scaledWidth;

    //  update world bounds

    setWorldBounds();
}



/**
 * adjust the world bounds to suit the new world size
 */
function setWorldBounds()
{
    game.physics.arcade.setBounds(gameConfig.tileWidth * -2, 0, game.world.width + gameConfig.tileWidth * 4, game.world.height);
}



// WEBPACK FOOTER //
// ./src/ts/game/scaling/Scaling.ts